import { ExecuteAPIGet, ExecuteAPIPost } from '../server-utils'
import { EndPoints } from '../endpoints'
// import { PollViewModel } from '../../models/poll-viewmodel'
// import { PollChoiceModel } from '../../models/poll-choice-models'
import { ChoiceViewModel, ListPollsDto, ListPollsResultModel, PollChoicePostViewModel, PollChoiceViewModel } from 'models/poll-choice-viewmodel'

export const PollUtils = {
  GetActivePoll: async function GetActivePoll() {
    return await ExecuteAPIGet<PollChoiceViewModel>(EndPoints.Poll.GetActivePoll)
  },
  Vote: async function Vote(model: ChoiceViewModel) {
    return await ExecuteAPIPost<number>(EndPoints.Poll.Vote, model)
  },
  CheckVotesByIP: async function CheckVotesByIP(pollId: number) {
    return await ExecuteAPIGet<boolean>(EndPoints.Poll.CheckVotesByIP, `pollId=${pollId}`)
  },
  GetAllPolls: async function GetAllPolls(filters:ListPollsDto) {
    return await ExecuteAPIPost<ListPollsResultModel>(EndPoints.Poll.GetAllPolls,filters)
  },
  GetPollById: async function GetPollById(id : number) {
    return await ExecuteAPIGet<PollChoiceViewModel>(EndPoints.Poll.GetPollById, `id=${id}`)
  },
  RemovePollChoice: async function RemovePollChoice(id: number) {
    return await ExecuteAPIGet<boolean>(EndPoints.Poll.RemovePollChoice, `id=${id}`)
  },
  AddPoll: async function AddPoll(model: PollChoicePostViewModel) {
    return await ExecuteAPIPost<PollChoiceViewModel>(EndPoints.Poll.AddPoll, model)
  },
  UpdatePoll: async function UpdatePoll(model: PollChoicePostViewModel) {
    return await ExecuteAPIPost<PollChoiceViewModel>(EndPoints.Poll.UpdatePoll, model)
  },
  StopPoll: async function StopPoll(id: number) {
    return await ExecuteAPIGet<boolean>(EndPoints.Poll.StopPoll, `id=${id}`)
  },
  DeletePoll: async function DeletePoll(id: number) {
    return await ExecuteAPIGet<boolean>(EndPoints.Poll.DeletePoll, `id=${id}`)
  },
  GetMaxFinishDate: async function GetMaxFinishDate(id:number) {
    return await ExecuteAPIGet<Date>(EndPoints.Poll.GetMaxFinishDate,`id=${id}`)
  },
  ResumePoll: async function ResumePoll(id: number) {
    return await ExecuteAPIGet<boolean>(EndPoints.Poll.ResumePoll, `id=${id}`)
  },
  GetTotalPollCount: async function GetTotalPollCount() {
    return await ExecuteAPIGet<number>(EndPoints.Poll.GetTotalPollCount)
  },
}
